import React from "react";
import { useNavigate } from "react-router-dom";

const StripeSuccess = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center h-screen text-center">
      <h1 className="text-3xl font-bold text-green-600 mb-3">✅ Stripe Connected!</h1>
      <p className="text-gray-700 mb-4">
        Your payout account has been successfully connected.
      </p>
      <button
        onClick={() => navigate("/payments")}
        className="bg-blue-600 hover:bg-blue-700 text-white px-5 py-2.5 rounded-lg font-semibold"
      >
        Back to Wallet
      </button>
    </div>
  );
};

export default StripeSuccess;
